

import React from "react";

const TaskStatusTabs = ({ tabs, activeTab, setActiveTab }) => {
  return (
    <div className="my-2">
      <div className="flex">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.label; // comparer avec label
          return (
            <button
              key={tab.label}
              type="button"
              className={`relative px-3 md:px-4 py-2 text-sm font-medium ${
                isActive ? "text-blue-600" : "text-gray-500 hover:text-gray-700"
              } cursor-pointer`}
              onClick={() => setActiveTab(tab.label)} // utiliser label pour le filtre
            >
              <div className="flex items-center">
                <span className="text-xs">{tab.label}</span>
                <span
                  className={`text-xs ml-2 px-2 py-0.5 rounded-full ${
                    isActive ? "bg-blue-600 text-white" : "bg-gray-200/70"
                  }`}
                >
                  {tab?.count ?? 0}
                </span>
              </div>

              {isActive && (
                <div className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-600 z-10" />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default TaskStatusTabs;

